import { PropsWithChildren } from 'react';
import { Card, CardHeader, CardBody, Container } from 'reactstrap';
import { LogoInduControl } from './LogoInducontrol';

interface ViewPageProps extends PropsWithChildren {
  title: string;
}

const ViewPage: React.FC<ViewPageProps> = ({ children, title }: ViewPageProps) => {
  const header = (
    <CardHeader>
      <div className="d-flex">
        <div className="flex-grow-1">
          <h2>{title}</h2>
        </div>
        <div className="align-self-end">
          <LogoInduControl />
        </div>
      </div>
    </CardHeader>
  );
  return (
    <Card style={{ minHeight: 'calc(100vh - 96px)' }}>
      {header}
      <CardBody>
        <Container>{children}</Container>
      </CardBody>
    </Card>
  );
};

export default ViewPage;
